import { Subscription } from "@rechargeapps/storefront-client";

export const limitSubscriptions = (subscriptions: Subscription[], product: any) => {
  // check if the product is already a subscription
  const activeSubscriptions = subscriptions?.filter(({ status }) => status === 'active');
  const allSubscriptionIds = activeSubscriptions?.map(({ external_product_id }) => external_product_id.ecommerce);
  const subscriptionExists = allSubscriptionIds?.includes(product.id);

  // count number of powder subscriptions
  const limitCounter = {};
  activeSubscriptions?.forEach((subscription) => {
    if (subscription.product.type === 'Powder') {
      limitCounter[subscription?.external_product_id?.ecommerce] = (limitCounter[subscription?.external_product_id?.ecommerce] || 0) + 1;
    }
  });

  const productIsLimited = Object.keys(limitCounter).includes(product.id);

  return {
    allowed: !((subscriptionExists && !productIsLimited) || (limitCounter[product.id] >= 2)),
  };
};